function initLazy() {

	document.addEventListener("DOMContentLoaded", function() {
		var lazyImages = [].slice.call(document.querySelectorAll("img.aos-init"));

		if ("IntersectionObserver" in window) {
			let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						let lazyImage = entry.target;
						// lazyImage.src = lazyImage.dataset.src;
						lazyImage.srcset = lazyImage.dataset.srcset;
						// lazyImage.classList.remove("lazy");
						lazyImage.classList.add("aos-animate");
						lazyImageObserver.unobserve(lazyImage);
					}
				});
			});

			lazyImages.forEach(function(lazyImage) {
				lazyImageObserver.observe(lazyImage);
			});
		} else {
			// Fall back to a more compatible method here
			// Handles Edge 15 cases
			console.log('running Edge fallback for lazy loading');
			lazyImages.forEach(function(element) {
				element.src = element.dataset.src;
				element.srcset = element.dataset.srcset;
				element.classList.remove('lazy');
			});
		}
	});

}

export default initLazy;
